import React from "react";
import { motion } from "framer-motion";
import { FaPlus, FaMagic } from "react-icons/fa";

interface NewEnrichmentButtonProps {
  onCreateEnrichment?: () => void;
}

/**
 * NewEnrichmentButton component - button to create a new enrichment from the sidebar.
 */
const NewEnrichmentButton: React.FC<NewEnrichmentButtonProps> = ({
  onCreateEnrichment,
}) => {
  const handleClick = () => {
    if (onCreateEnrichment) {
      onCreateEnrichment();
    }
  };

  return (
    <div className="px-3 py-2">
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={handleClick}
        className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-dashed transition-all border-[var(--arc-sidebar-border-accent)] text-[var(--arc-sidebar-text-secondary)] hover:text-[var(--arc-sidebar-text-primary)] hover:border-[var(--arc-accent)] hover:bg-[var(--arc-sidebar-accent-glow)]"
      >
        <FaPlus size={12} />
        <span className="text-sm">Nouvel enrichissement</span>
      </motion.button>
    </div>
  );
};

NewEnrichmentButton.displayName = "NewEnrichmentButton";

export default NewEnrichmentButton;
